import api from "../_app/api";
import {
  CreateTicket,
  GetTicketCommentsParams,
  GetTicketCommentsResponse,
  GetTicketsResponse,
  Ticket,
  TicketComment,
} from "./types";

export const getTickets = async (accountId: string, page: number, limit: number) => {
  const { data }: { data: GetTicketsResponse } = await api({
    method: "GET",
    url: "/support",
    params: {
      page,
      size: limit,
      "account-id": accountId,
    },
  });
  return data;
};

export const getTicketById = async (accountId: string, ticketId: string) => {
  const { data }: { data: Ticket } = await api({
    method: "GET",
    url: `/support/${ticketId}`,
    params: { "account-id": accountId },
  });
  return data;
};

export const createTicket = async (accountId: string, ticket: CreateTicket) => {
  const { data }: { data: Ticket } = await api({
    method: "POST",
    url: "/support",
    params: { "account-id": accountId },
    data: ticket,
  });
  return data;
};

export const getTicketComments = async (params: GetTicketCommentsParams) => {
  const { ticketId, accountId, ...parsed } = params;
  let { data }: { data: GetTicketCommentsResponse } = await api({
    method: "GET",
    url: `/support/${ticketId}/comments`,
    params: {
      ...parsed,
      "account-id": accountId,
    },
  });
  return data;
};

export const createTicketComment = async (accountId: string, ticketId: any, comment: string) => {
  const { data }: { data: TicketComment } = await api({
    method: "POST",
    url: `/support/${ticketId}/comments`,
    params: { "account-id": accountId },
    data: { comment },
  });
  return data;
};
